// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const UnfoldLessIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="UnfoldLessIcon" ref={forwardedRef} {...props}>
      <path d="M14.243 15.743 10 11.5l-4.243 4.243 1.061 1.06L10 13.621l3.182 3.182z" />
      <path d="M5.757 4.257 10 8.5l4.243-4.243-1.061-1.06L10 6.379 6.818 3.197z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const UnfoldLessIcon = /* @__PURE__ */ Object.assign(
  UnfoldLessIconComponent,
  { displayName: 'UnfoldLessIcon' },
);
